<template>
  <el-card v-if="trackList.length" class="box-card" shadow="never">
    <div v-if="!hideHeader" slot="header">
      <span>{{ title }}</span>
    </div>
    <div class="track-item" v-for="(track, index) in trackList" :key="index">
      <div class="track-type">
        <span v-if="showType">{{ ['', '客户端监测', '服务端监测'][track.trackType] }}</span>
        <span>{{ track.serviceProvider }}</span>
        <span>{{ trackTypeModelObj[track.trackTypeModel] }}</span>
        <span v-if="title === '定点监测'">{{ track.point }}秒</span>
      </div>
      <div class="track-code">{{ track.code }}</div>
    </div>
  </el-card>
</template>

<script>
import { trackTypeModelObj } from '../MaterialCreative'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    trackList: {
      type: Array,
      default: () => []
    },
    showType: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      trackTypeModelObj
    }
  }
}
</script>

<style lang="stylus" scoped>
.track-item
  margin-bottom 20px
  font-size 14px
.track-type
  margin-bottom 6px
  span
    padding-right 20px
.track-code
  line-height 20px
  font-size 12px
  color #606060
  word-break break-all
</style>
